import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import {constants} from '../../config/constants';
import './styles.css';

function Index() {

  const [progress, setProgress] = useState(0);
  const {
    allmenu
  } = useSelector((state) => state.initLoad);

  useEffect(() => {
    let id;
    id = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 3;
        if (next >= 90) {
          clearInterval(id);
          return 90;
        }
        return next;
      });
    }, 120);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (allmenu) {
      const timeout = setTimeout(() => setProgress(100), 300);
      return () => clearTimeout(timeout);
    }
  }, [allmenu]);

  return (
    <div
      style={{
       // backgroundImage: `url(${require('./assets/splash_bk.jpg')})`,
        backgroundSize: 'cover',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
      }}
    >
      <img
        className={'logo'}
        src={require('./assets/franciscas-logo_White.png')}
        alt="Logo"
      />

      <div style={{width: '80%', maxWidth: 480, position: 'absolute', bottom: 64}}>
        <p style={{
          color: 'white',
          textAlign: 'center',
          marginBottom: 10,
          fontWeight: 700,
          letterSpacing: 1
        }}>
          TU MENÚ ACTUALIZADO ESTÁ CARGANDO...
        </p>
        <div style={{
          height: 8,
          backgroundColor: 'rgba(255,255,255,0.25)',
          borderRadius: 6,
          overflow: 'hidden'
        }}>
          <div style={{
            height: '100%',
            width: `${progress}%`,
            backgroundColor: '#ffffff',
            transition: 'width 200ms ease'
          }} />
        </div>
        <p style={{
          color: '#bdbdbd',
          textAlign: 'center',
          marginTop: 8,
          fontSize: 12
        }}>
          {progress}%
        </p>
      </div>

      <div style={{
        position: 'absolute',
        bottom: 0,
        textAlign: 'center',
        backgroundColor: 'black',
        width: '100%'
      }}>
        <p style={{color: 'white'}}>Powered by boostyourmenu.com</p>
      </div>
    </div>
  );
}

export default Index;
